import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { APP_VERSION } from './version';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

reportWebVitals(); 

async function checkAppVersion() {
    try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        if (!response.ok) return;
        const data = await response.json();
        if (data.version && data.version !== APP_VERSION) {
            console.log('New app version detected:', data.version, 'current:', APP_VERSION);
            window.location.reload();
        }
    } catch (e) {
        // ignore errors if version check fails
    }
}

(async function unregisterServiceWorkersAndClearCaches() {
    try {
        if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            await Promise.all(regs.map(r => r.unregister()));
        }
        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map(k => caches.delete(k)));
        }
    } catch (e) {
        // ignore errors
    }
    await checkAppVersion();
    setInterval(checkAppVersion, 5 * 60 * 1000);
})();